'use client';

import {Dispatch} from 'react';
import {ActionTypes} from '@/lib/context/actionTypes';
import {ActionMap} from '@/lib/context/actionMap';

// Define Interfaces
interface UpdateMenuAction {
  type: ActionTypes.UpdateUserInterfaceMenuStatus;
  payload: {
    menuOpen: boolean;
  };
}
interface UpdateMenuView {
  type: ActionTypes.UpdateUserInterfaceMenuView;
  payload: {
    menuView: string;
  };
}
// Define Types
type UserInterfacePayload = {
  [ActionTypes.UpdateUserInterfaceMenuStatus]: {
    menuOpen: boolean;
  };
  [ActionTypes.UpdateUserInterfaceMenuView]: {
    menuView: string;
  },
};

export type UserInterfaceActions = ActionMap<UserInterfacePayload>[keyof ActionMap<UserInterfacePayload>];

export const setMenuStatus = (dispatch: Dispatch<UpdateMenuAction>, status: boolean) => {
  dispatch({type: ActionTypes.UpdateUserInterfaceMenuStatus, payload: {menuOpen: status}});
};

export const setMenuView = (dispatch: Dispatch<UpdateMenuView>, menuView: string) => {
  dispatch({type: ActionTypes.UpdateUserInterfaceMenuView, payload: {menuView: menuView}});
};
